import React from "react";
import FeatherIcon from "feather-icons-react";

/**
 * Botón de descarga compartido para las barras de filtros (Documentos y
 * Conciliación). Centraliza el ícono, el estado de carga (spinner) y el tooltip
 * para que se vean/comporten idéntico en todos los módulos.
 *
 * @param {() => void} onClick  Handler de descarga.
 * @param {boolean} loading     Muestra el spinner y bloquea el clic.
 * @param {string} label        Texto del tooltip.
 * @param {string} iconClassName Clase del wrapper para heredar el estilo del
 *   grupo de íconos del módulo ('document-filter-icon' | 'reconcile-filter-icon').
 *
 * Se renderiza como su propio "pill" (mismo fondo/borde que el grupo de íconos)
 * para que se vea como un grupo distinto, separado del resto de los filtros.
 */
const DownloadFilteredButton = ({
  onClick,
  loading = false,
  label,
  iconClassName = "",
}) => (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      backgroundColor: "#f3f4f6",
      borderRadius: "8px",
      padding: "3px",
      flexShrink: 0,
    }}
  >
    <div
      className={iconClassName}
      title={label}
      onClick={() => !loading && onClick && onClick()}
      style={{ cursor: loading ? "wait" : "pointer" }}
    >
      <FeatherIcon
        icon={loading ? "loader" : "download"}
        size={16}
        className={`tw-text-gray-600${loading ? " tw-animate-spin" : ""}`}
      />
    </div>
  </div>
);

export default DownloadFilteredButton;
